export default "/images/41ca5e170cef78898a6b4a66f9b25242.avif";